import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Template } from "src/app/settings/models/template";
import {
  EMAIL_BOX_FIELD,
  EMAIL_BOX_FIELD_CONTROLS,
} from "./email-standalone-fields";
import { GenerateDocumentDialogData } from "./generate-document-dialog-data";
import { CotecnaUserService } from "@cotecna/session";
import {
  INSPECTOR_ROLE,
  SERVICE_PROVIDER_INSPECTOR_ROLE,
} from "../../constants/constants";

@Component({
  selector: "im-generate-document-dialog",
  templateUrl: "./generate-document-dialog.component.html",
  styleUrls: ["./generate-document-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GenerateDocumentDialogComponent implements OnInit {
  public templates: Template[];
  public template: Template = null;

  public items: any[] = [];
  public selectedItems: any[] = [];
  public allItemsSelected: boolean = true;
  public showItems: any[] = [];

  public emailBoxField = { ...EMAIL_BOX_FIELD };
  public emailBoxFieldControl = { ...EMAIL_BOX_FIELD_CONTROLS };

  private emailsToSend: string[] = [];

  public isPdf: boolean = false;
  public reportBasedOnCode: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<GenerateDocumentDialogComponent>,
    private cotecnaUserService: CotecnaUserService,
    @Inject(MAT_DIALOG_DATA) private dialogData: GenerateDocumentDialogData,
  ) {}

  public async ngOnInit(): Promise<void> {
    this.updateDefaultEmails([]);
    this.items = [{ id: "ALL", name: "ALL" }, ...this.dialogData.items];
    this.showItems = this.items;
    this.selectedItems = [{ id: "ALL", name: "ALL" }];
    this.allItemsSelected = true;
    this.templates = this.dialogData.templates.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  }

  public selectTemplate(template): void {
    this.template = template;
    if (this.template.defaultEmails === undefined) {
      this.template.defaultEmails = [];
    }
    this.isPdf = this.template.isPdfByDefault;
    this.reportBasedOnCode = this.template.reportBasedOnCode;
    this.updateDefaultEmails(this.template.defaultEmails);
    this.emailBoxField.value = [];
    if (this.isOnlyInspector())
      this.emailBoxField.readOnly = !this.template.allowAdditionalEmails;
  }

  public selectionItem(items): void {
    const allItem = { id: "ALL", name: "ALL" };
    const isAllInItems = items.some(
      (item) => item.id === "ALL" && item.name === "ALL",
    );
    const wasAllSelected = this.selectedItems.some(
      (item) => item.id === "ALL" && item.name === "ALL",
    );
    const itemsWithoutAll = items.filter((item) => item.id !== "ALL");
    const totalRealItems = this.items.filter((item) => item.id !== "ALL");

    if (isAllInItems && !wasAllSelected) {
      this.allItemsSelected = true;
      this.selectedItems = [allItem];
      this.showItems = this.items;
      return;
    }

    if (!isAllInItems && wasAllSelected) {
      this.allItemsSelected = false;
      this.selectedItems = [];
      this.showItems = [];
      return;
    }

    if (wasAllSelected && itemsWithoutAll.length < totalRealItems.length) {
      this.allItemsSelected = false;
      this.selectedItems = itemsWithoutAll;
      this.showItems = itemsWithoutAll;
      return;
    }

    if (itemsWithoutAll.length === totalRealItems.length) {
      this.allItemsSelected = true;
      this.selectedItems = [allItem];
      this.showItems = this.items;
      return;
    }

    this.allItemsSelected = false;
    this.selectedItems = itemsWithoutAll;
    this.showItems = itemsWithoutAll;
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

  public generateDocument(): void {
    this.emailBoxFieldControl.defaultEmails.forEach((email) =>
      this.emailsToSend.push(email),
    );
    this.dialogRef.close({
      templateId: this.template.templateId,
      itemsId: this.selectedItems.map((sI) => sI.id),
      isPdf: this.isPdf,
      emailsToSend: this.emailsToSend,
      reportBasedOnCode: this.reportBasedOnCode,
    });
  }

  public onPdfToggleChange(isPdf: boolean): void {
    this.isPdf = !isPdf;
  }

  public onEmailAdded(event: any): void {
    this.emailsToSend = event.detail.value;
  }

  private updateDefaultEmails(defaultEmails: string[]): void {
    this.emailBoxFieldControl = {
      ...this.emailBoxFieldControl,
      defaultEmails: defaultEmails,
    };
  }

  public isOnlyInspector(): boolean {
    const roles = this.cotecnaUserService.getUser().roles;
    return (
      roles.length === 1 &&
      (roles[0] === INSPECTOR_ROLE ||
        roles[0] === SERVICE_PROVIDER_INSPECTOR_ROLE)
    );
  }
}
